import React, { useState } from "react";
import TitleBar from "../../layout/TitleBar";
import Layout from "../../layout/Layout";
import { addUserToDB } from "../../../actions/auth";
import Alert from "../../layout/Alert";
import LoadingOverlay from "react-loading-overlay";
import ScaleLoader from "react-spinners/ScaleLoader";
import { setAlert } from "../../../actions/alert";
import { useDispatch } from "react-redux";
import { EyeIcon, EyeOffIcon } from "../../icons";

const AddUser = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password2: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const clearFormData = () => {
    setFormData({
      name: "",
      email: "",
      password: "",
      password2: "",
    });
  };
  const [isloading, setIsloading] = useState(false);
  const { name, email, password, password2 } = formData;
  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePassword2Visibility = () => {
    setShowPassword2(!showPassword2);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);
    if (password !== password2) {
      //   setAlert("Password do not match", "danger", 3000);
      dispatch(setAlert("Password do not match.", "danger"));
    } else {
      var res = await addUserToDB(name, email, password);
      const token = res.token;
      if (!token) {
        if (res[0].response.status === 400) {
          res[0].response.data.errors.map((e) => {
            dispatch(setAlert(e.msg, "danger"));
          });
        }
      } else {
        dispatch(setAlert("User has been created.", "success"));
        clearFormData();
      }
    }
    setIsloading(false);
  };

  return (
    <LoadingOverlay
      active={isloading}
      spinner={<ScaleLoader color="#36D7B7" />}
    >
      <Layout>
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 w-100">
          <TitleBar title="Add New Admin User" />
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-5">
                <form onSubmit={(e) => onSubmit(e)}>

                  <div className="card mb-3">
                    <div className="card-header">User details</div>
                    <div className="card-body">

                      <div className="mb-3">
                        <label className="label mb-2">Name:</label>
                        <div className="col-sm-12">
                          <input
                            type="text"
                            className="form-control form-control-admin"
                            id="name"
                            placeholder="Enter name"
                            name="name"
                            value={name}
                            onChange={(e) => onChange(e)}
                            required
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="label mb-2">Email:</label>
                        <div className="col-sm-12">
                          <input
                            type="text"
                            className="form-control form-control-admin"
                            id="name"
                            placeholder="Enter Email"
                            name="email"
                            value={email}
                            onChange={(e) => onChange(e)}
                            required
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="label mb-2">Password:</label>
                        <div className="col-sm-12 position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control form-control-admin"
                            placeholder="Password"
                            name="password"
                            value={password}
                            onChange={(e) => onChange(e)}
                            style={{ paddingRight: '45px' }}
                            required
                          />
                          <div 
                            onClick={togglePasswordVisibility}
                            style={{ 
                              position: 'absolute',
                              right: '13px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                              zIndex: 5,
                              display: 'flex',
                              alignItems: 'center',
                              padding: '4px'
                            }}
                          >
                            {showPassword ? (
                              <EyeIcon />
                            ) : (
                              <EyeOffIcon />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="label mb-2">Confirm Password:</label>
                        <div className="col-sm-12 position-relative">
                          <input
                            type={showPassword2 ? "text" : "password"}
                            className="form-control form-control-admin"
                            placeholder="Confirm Password"
                            name="password2"
                            value={password2}
                            onChange={(e) => onChange(e)}
                            style={{ paddingRight: '45px' }}
                            required
                          />
                          <div 
                            onClick={togglePassword2Visibility}
                            style={{ 
                              position: 'absolute',
                              right: '13px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                              zIndex: 5,
                              display: 'flex',
                              alignItems: 'center',
                              padding: '4px'
                            }}
                          >
                            {showPassword2 ? (
                              <EyeIcon />
                            ) : (
                              <EyeOffIcon />
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="col-sm-offset-2 col-sm-10">
                      <button type="submit" className="btn btn-primary">
                        <i
                          className="fa fa-plus-circle fa-fw"
                          aria-hidden="true"
                        ></i>{" "}
                        Add User
                      </button>
                    </div>
                  </div>
                  
                </form>
              </div>
            </div>
          </div>
          <Alert />
        </main>
      </Layout>
    </LoadingOverlay>
  );
};

export default AddUser;
